import * as Yup from "yup";

export const saleVoiceSchema = Yup.object().shape({
  selectedSaleServices: Yup.array().required(
    "Please select a services or products"
  ),
  packages: Yup.array().when("selectedSaleServices", {
    is: (selectedSaleServices) =>
      selectedSaleServices.some((item) => item?.value === 1),
    then: Yup.array().required("Please select a package"),
  }),
  products: Yup.array().when("selectedSaleServices", {
    is: (selectedSaleServices) =>
      selectedSaleServices.some((item) => item?.value === 2),
    then: Yup.array().required("Please select a product"),
  }),
  paymentStatus: Yup.string().required("Payment info is required"),
  paymentType: Yup.string().required("Payment Type is required"),
  receivedAmount: Yup.number().when("paymentStatus", {
    is: "partialPayment",
    then: Yup.number().required("Please enter the received amount"),
  }),
  split: Yup.array().when("paymentType", {
    is: "SP",
    then: Yup.array().of(
      Yup.object().shape({
        type: Yup.string().required("Split type is required"),
        amount: Yup.number().required("Split amount is required"),
      })
    ),
    otherwise: Yup.array().notRequired(),
  }),
  tax: Yup.number().required("Please enter tax percentage"),
});
